import {all, call, fork, put, select} from "redux-saga/effects";
import {IApplicationState} from "../..";
import {startLevel} from "../actions";
import fetchLevelMaps from "./handleFetchLevelMaps";
import fetchCategories from "./handleFetchCategories";
import {loadScene} from "../../routing/actions";
import loadAndShowQuestion from "./loadAndShowQuestion";
import {ISharedEntryPoint} from "../../common/types";

function* showEntryQuestion(questionId: number) {
    const isSucceed = yield loadAndShowQuestion(questionId, function* () {
        yield put(loadScene.request('Question'));
    });

    if (!isSucceed) {
        return;
    }

    const {level, scenery} = yield select(({ game, player }: IApplicationState) => ({
        level: player.levelsCompleted + 1,
        scenery: game.levelScenery,
    }));

    yield all([
        fork(fetchCategories),
        fork(fetchLevelMaps),
    ]);

    yield put(startLevel({level, scenery}));
}

export default function* handleEntryPoint(entryPoint: ISharedEntryPoint) {
    if (entryPoint.questionId) {
        yield call(showEntryQuestion, entryPoint.questionId);
    }
}